import React, { useEffect, useState } from "react"
import { RadioGroup } from "@headlessui/react"
import classNames from "~/utils/classNames"
import { accessOptions } from "../../constants/AccessRadioOptions"
import { ReservationOptionsSelectorProps } from "../../interfaces/UserFieldInterfaces"

export default function UserAccessOptionsSelector({
  selectedAccess,
  setSelectedOption,
}: ReservationOptionsSelectorProps) {
  const [options, setOptions] = useState<any[]>(accessOptions)
  const [selected, setSelected] = useState<any>(
    selectedAccess ? options.find((option) => option.value === selectedAccess) : options[0],
  )

  useEffect(() => {
    if (selected) {
      setSelectedOption(selected.value)
    }
  }, [selected])

  return (
    <RadioGroup value={selected} onChange={setSelected} className={"mb-4"}>
      <label className="block font-semibold text-md text-gray-900 mb-0.5">Role</label>
      <div className="-space-y-px rounded-md bg-white">
        {options.map((option, optionIdx) => (
          <RadioGroup.Option
            key={option.name}
            value={option}
            className={({ checked }) =>
              classNames(
                optionIdx === 0 ? "rounded-tl-md rounded-tr-md" : "",
                optionIdx === options.length - 1 ? "rounded-bl-md rounded-br-md" : "",
                checked ? "z-10 border-green-200 bg-green-50" : "border-gray-200",
                "relative flex items-center cursor-pointer border p-4 focus:outline-none",
              )
            }
          >
            {({ active, checked }) => (
              <>
                <span
                  className={classNames(
                    checked ? "bg-green-600 border-transparent" : "bg-white border-gray-300",
                    active ? "ring-2 ring-offset-2 ring-green-600" : "",
                    "mt-0.5 h-4 w-4 shrink-0 cursor-pointer rounded-full border flex items-center justify-center flex-shrink-0",
                  )}
                  aria-hidden="true"
                >
                  <span className="rounded-full bg-white w-1.5 h-1.5" />
                </span>
                <span className="ml-3 flex flex-col">
                  <RadioGroup.Label
                    as="span"
                    className={classNames(checked ? "text-green-900" : "text-gray-900", "block text-md font-semibold")}
                  >
                    {option.name}
                  </RadioGroup.Label>
                  {checked && option.description?.length && (
                    <RadioGroup.Description
                      as="span"
                      className={classNames(checked ? "text-green-600" : "text-gray-500", "block text-md mt-1 font-semibold")}
                    >
                      {option.description}
                    </RadioGroup.Description>
                  )}
                </span>
              </>
            )}
          </RadioGroup.Option>
        ))}
      </div>
    </RadioGroup>
  )
}
